module.exports = __webpack_public_path__ + "static/media/springer_logo.bf877eaa.png";